import React, { Component } from "react";
import { connect } from "react-redux";
import {
  customerList,
  customerCreateReset,
  customerCreate,
  customerUpdate,
  customerDelete,
  customerSelect,
  getCustomerTargets4,
  getCustomerTargets6,
  updateCustomerTargets4,
  updateCustomerTargets6,
  CustTargets4Reset,
  CustTargets6Reset,
  resetJobList,
  getWireMap,
  getCableList,
  updateCableList,
  DeleteCable,
  countryStateList,
  getSmartFlagProfiles
} from "../../redux/actions";

import {
  getActiveLanguage
} from 'react-localize-redux'

import { removeLogo } from "../../common/storage";

import { preparePager, prepareSearch } from "../../common/tabletools";

import NoData from "../../components/nodata";
import Customers from "../../components/customers";

class CustomersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pager: {
        defaultColumns: [
          "name",
          "contactfirstname",
          "contactlastname",
          "contactemail"
        ],
        manual: true,
        pageno: 1,
        pagesize: 5,
        order: {},
        search: [],
        global: false
      }
      // customerTargets4: null,
      // customerTargets6: null
      // customerTargets4: [
      //   {
      //     id: 7,
      //     name: "google.com"
      //   },
      //   {
      //     id: 8,
      //     name: "bbc.co.uk"
      //   },
      //   {
      //     id: 9,
      //     name: "cloudthing.com"
      //   }
      // ],
      // customerTargets6: [
      //   {
      //     id: 7,
      //     name: "yahoo.com"
      //   },
      //   {
      //     id: 8,
      //     name: "tv9.co.uk"
      //   },
      //   {
      //     id: 9,
      //     name: "idealnetworks.com"
      //   }
      // ]
    };
    this.fetch = this.fetch.bind(this);
    this.search = this.search.bind(this);
  }

  componentWillMount() {
    this.props.resetCustomer();
    this.props.resetCustTargets4();
    this.props.resetCustTargets6();
    this.props.getCustomers(this.state.pager);
    this.props.getCountryStateList(this.props.activeLanguage);
  }

  componentWillReceiveProps(nextProps) {
    const { customerTargets4, customerTargets6 } = nextProps;

    if (this.props.customerTargets4 !== customerTargets4) {
      //let xyz = [...];
      this.setState({
        customerTargets4: nextProps.customerTargets4
      });
    }
    if (this.props.customerTargets6 !== customerTargets6) {
      //let xyz = [...];
      this.setState({
        customerTargets6: nextProps.customerTargets6
      });
    }
  }

  fetch(table) {
    const { pager } = this.state;
    if (!pager.global) this.props.getCustomers(preparePager(table, pager));
    else {
      let search = pager.search;
      let pagers = preparePager(table, pager);
      if (pagers.search.length > 0) {
        pagers.search = [...search, ...pagers.search];
      } else {
        pagers.search = search;
      }
      this.props.getCustomers(pagers);
    }
  }

  search(term) {
    const { pager } = this.state;
    const { customers } = this.props;
    const { columns } = customers;
    const _pager = prepareSearch(term, columns, pager);
    _pager.global = term === "" ? false : true;
    this.setState({
      pager: _pager
    });
    this.props.getCustomers(_pager);
  }

  removeLogo(id) {
    removeLogo("customer", id);
  }

  componentDidMount() {
    const { resetJobList, profile, getSmartFlagProfiles } = this.props;
    resetJobList();

    if (profile) {
      const activeFeatures = this.props.appSettingReducer?.activeFeatures;
      if (activeFeatures?.some(f => f.featureName === 'smart_flag')) {
        getSmartFlagProfiles(profile.customerid);
      }
    }
  }

  render() {
    const {
      translate,
      languages,
      create,
      created,
      customerId,
      customer,
      customers,
      getCustomer,
      update,
      del,
      resetCustomer,
      customerTargets4,
      customerTargets6,
      getCustTargets4,
      getCustTargets6,
      updateCustTargets4,
      updateCustTargets6,
      roles,
      cableList,
      getCableList,
      wireMap,
      getWireMap,
      countryStates,
      smartFlagProfiles,
    } = this.props;
    const {
      pager,
      customerTargets
    } = this.state;

    return customers ? (
      <Customers
        translate={translate}
        languages={languages}
        create={create}
        created={created}
        customerId={customerId}
        customer={customer}
        customers={customers}
        pager={pager}
        update={update}
        fetch={this.fetch}
        search={this.search}
        resetCustomer={resetCustomer}
        get={getCustomer}
        del={del}
        removeLogo={this.removeLogo}
        getTargets4={getCustTargets4}
        getTargets6={getCustTargets6}
        customerTargets4={customerTargets4}
        customerTargets6={customerTargets6}
        updateCustTargets4={updateCustTargets4}
        updateCustTargets6={updateCustTargets6}
        roles={roles}
        getCableList={getCableList}
        wireMap={wireMap}
        getWireMap={getWireMap}
        cableList={cableList}
        updateCableList={this.props.updateCableList}
        DeleteCable={ this.props.DeleteCable }
        countryStates={countryStates}
        smartFlagProfiles={smartFlagProfiles}
        activeFeatures={this.props.appSettingReducer?.activeFeatures}
      />
    ) : null;
  }
}
const mapStateToProps = state => ({
  languages: state.localeReducer.languages,
  customerId: state.customerReducer.customerId,
  customer: state.customerReducer.customer,
  customers: state.customerReducer.customers,
  created: state.customerReducer.created,
  updated: state.customerReducer.updated,
  customerTargets4: state.customerReducer.customerTargets4, //ADD REDUCER INTO THE PATH
  customerTargets6: state.customerReducer.customerTargets6,
  cableList: state.subtestReducer.cableList,
  wireMap: state.subtestReducer.wireMap,
  countryStates: state.customerReducer.countryStates,
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  smartFlagProfiles: state.smartFlagProfileReducer.profiles,
  profile: state.profileReducer.profile,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  getCustomers: pager => {
    dispatch(customerList(pager));
  },
  create: (customer, pager) => {
    return dispatch(customerCreate("customer", customer, pager));
  },
  update: (customer, pager) => {
    return dispatch(customerUpdate("customer", customer, pager));
  },
  getCustomer: id => {
    dispatch(customerSelect(id));
  },
  resetCustomer: () => {
    dispatch(customerCreateReset());
  },
  del: (id, pager) => {
    return dispatch(customerDelete("customer", id, pager));
  },
  getCustTargets4: id => {
    dispatch(getCustomerTargets4(id));
  },
  getCustTargets6: id => {
    dispatch(getCustomerTargets6(id));
  },
  updateCustTargets4: (id, targetList) => {
    dispatch(updateCustomerTargets4(id, targetList));
  },
  updateCustTargets6: (id, targetList) => {
    dispatch(updateCustomerTargets6(id, targetList));
  },
  resetCustTargets4: () => {
    dispatch(CustTargets4Reset());
  },
  resetCustTargets6: () => {
    dispatch(CustTargets6Reset());
  },
  resetJobList: () => {
    dispatch(resetJobList());
  },
  getWireMap: () => {
    dispatch(getWireMap());
  },
  getCableList: id => {
    dispatch(getCableList(id));
  },
  updateCableList: details => {
    dispatch(updateCableList(details));
  },
  DeleteCable: (id, custId) => {
    dispatch(DeleteCable(id, custId));
  },
  getCountryStateList: (languageCode) => {
    dispatch(countryStateList(languageCode));
  },
  getSmartFlagProfiles: (organisationId) => {
    dispatch(getSmartFlagProfiles(organisationId));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomersPage);
